export default "__VITE_ASSET__DP_s5MgD__"